import styled from '@emotion/styled';
import { Button as AntButton, Typography } from 'antd';

const { Paragraph } = Typography;

const INITIAL_HEIGHT = '40px';
const INITIAL_WIDTH = '120px';
const INITIAL_FONT_SIZE = '1rem';

// Helper function to scale size values (supports rem, px, em)
const scaleSize = (
  size: string | undefined,
  scale: number,
  fallback: string,
): string => {
  if (!size) return scaleSize(fallback, scale, fallback);

  const match = size.match(/^(\d+\.?\d*)(rem|px|em)$/);
  if (!match) return size;

  const value = parseFloat(match[1]) * scale;
  const unit = match[2];
  return `${value.toFixed(2)}${unit}`;
};

export const OutlinedButton = styled(AntButton)<{
  height?: string;
  width?: string;
  fontSize?: string;
}>`
  /* Desktop size - use props or defaults */
  height: ${(props) => props.height || INITIAL_HEIGHT};
  width: ${(props) => props.width || INITIAL_WIDTH};
  min-width: ${(props) => props.width || INITIAL_WIDTH};
  font-size: ${(props) => props.fontSize || INITIAL_FONT_SIZE};
  font-weight: bold;
  border-width: 6px;
  padding: 0 1.5rem;

  .button-text {
    color: inherit;
  }

  &:hover {
    .button-text {
      color: inherit;
    }
  }

  /* RWD - Tablet (768px and below) - Scale to 90% */
  @media (max-width: 768px) {
    height: ${(props) => scaleSize(props.height, 0.9, INITIAL_HEIGHT)};
    width: ${(props) => scaleSize(props.width, 0.9, INITIAL_WIDTH)};
    min-width: ${(props) => scaleSize(props.width, 0.9, INITIAL_WIDTH)};
    font-size: ${(props) => scaleSize(props.fontSize, 0.9, INITIAL_FONT_SIZE)};
    border-width: 5px;
    padding: 0 1.25rem;
  }

  /* RWD - Mobile (480px and below) - Scale to 75% */
  @media (max-width: 480px) {
    height: ${(props) => scaleSize(props.height, 0.75, INITIAL_HEIGHT)};
    width: ${(props) => scaleSize(props.width, 0.75, INITIAL_WIDTH)};
    min-width: ${(props) => scaleSize(props.width, 0.75, INITIAL_WIDTH)};
    max-width: ${(props) =>
      scaleSize(
        props.width,
        1.5,
        INITIAL_WIDTH,
      )}; /* Allow up to 150% of scaled width */
    font-size: ${(props) => scaleSize(props.fontSize, 0.8, INITIAL_FONT_SIZE)};
    border-width: 4px;
    padding: 0 0.75rem;
  }
`;

export const OutlinedButtonText = styled(Paragraph)`
  && {
    margin: unset;

    font-size: 1rem;

    @media (max-width: 768px) {
      font-size: 0.875rem;
    }

    @media (max-width: 480px) {
      font-size: 0.625rem;
    }
  }
`;
